<template>
  <div class="card">
    <div class="card-body bg-info text-center p-15 head">
      <p class="head">
        <strong>Our Last Week Provider Based Reservations Report</strong>
        <Btn
          class="btn waves-effect text-left btn-success btn-sm btn-success"
          @click="get()"
          :process="data == null"
        >
          <span>Yenile</span>
        </Btn>
      </p>
    </div>
    <div class="card-body p-0">
      <load-area v-if="data == null"></load-area>
      <apexChart
        :data="getDatasets()"
        :height="337"
        :chartOptions="chartOptions"
        v-if="data != null"
      ></apexChart>
    </div>
  </div>
</template>

<script>
import apexChart from "../../components/apexChart.vue";
export default {
  name: "usingReport",
  components: { apexChart },
  data() {
    return {
      tab: "usingReport",
      data: null,
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          height: 600,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        xaxis: {
          categories: [],
        },
        fill: {
          colors: ["#55ce63", "#ffb22b", "#fc4b6c", "#6c757d"],
        },
      },
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      var startDate = new Date();
      startDate.setDate(startDate.getDate() - 6);
      this.$appAxiosAdmin
        .post(`KOLAYREZ/Reports/ProviderBasedReservations`, {
          StartDate: this.$moment(new Date(startDate)).format("YYYY-MM-DD"),
          EndDate: this.$moment(new Date()).format("YYYY-MM-DD"),
        })
        .then((response) => {
          this.data = response.data.sort((x, y) => y.Total - x.Total);
          console.log(this.data);
        });
    },
    getDatasets() {
      var news = [];
      var changed = [];
      var cancelled = [];
      var other = [];
      //   var total = [];
      let xAxis = [];
      let count = (window.innerWidth / 40).toFixed(0);
      this.data.forEach((element, index) => {
        if (index < count) {
          xAxis.push(element.ProviderName);
          news.push(element.New);
          changed.push(element.Changed);
          cancelled.push(element.Cancelled);
          other.push(element.Other);
        }
        // total.push(element.Total);
      });
      this.chartOptions.xaxis.categories = xAxis;
      return [
        {
          name: "New",
          data: news,
          color: "#55ce63",
        },
        {
          name: "Changed",
          data: changed,
          color: "#ffb22b",
        },
        {
          name: "Cancelled",
          data: cancelled,
          color: "#fc4b6c",
        },
        {
          name: "Other",
          data: other,
          color: "#6c757d",
        },
      ];
    },
    getSum(type) {
      let sum = 0;
      this.data.Summary.forEach((element) => {
        sum += element[type];
      });
      return sum;
    },
  },
};
</script>
<style scoped>
.head {
  position: relative;
}
.head .btn {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -17px;
}
.card-body {
  overflow: hidden;
}
.head strong {
  color: #fff;
  font-weight: 500;
}
.right {
  padding: 16px 31px 16px 16px;
}
.right > .row {
  margin: -8px;
}
.right > .row > div {
  padding: 8px;
}
.right > .row > div .card {
  margin-bottom: 0;
}
.round-success {
  background: #55ce63;
}
.bg-success {
  background: #55ce63 !important;
}
@media (max-width: 991px) {
  .left {
    padding-right: 15px;
    border-right: none !important;
  }
  .right > .row {
    margin: -4px;
  }
  .right > .row > div {
    padding: 4px;
  }
  .right > .row > div .round {
    width: 36px;
    height: 36px;
  }
  .right > .row > div .round i {
    display: block;
    line-height: 36px;
  }
  .right > .row > div h4 {
    font-size: 16px;
  }
  .right > .row > div h6 {
    font-size: 12px;
  }
}
@media (max-width: 767px) {
  .left,
  /deep/ .left {
    padding-right: 15px !important;
  }
  .right {
    padding: 16px 31px;
    border-top: 1px solid #dee2e6 !important;
  }
}
</style>
